let tillArr = []
const arrayShuffle = (array) => {
  for (let i = array.length - 1; 0 < i; i--) {
    let r = Math.floor(Math.random() * (i + 1))
    let tmp = array[i]
    array[i] = array[r]
    array[r] = tmp
  }
  return array
}
if (window.tillCC) tillArr = window.tillCC
window.addEventListener('DOMContentLoaded', () => {
  // console.log('DOMContentLoaded')
  let sid = null
  const tillcs = document.querySelector('.tillcards')
  const mt = document.querySelector('.main-txt')
  const kz = document.querySelector('.kazashite')
  const tn = document.querySelector('.tsunagaru')
  const wv = document.querySelector('.wave')
  const wv2 = document.querySelector('.wave2')
  // const SelectStyle = getComputedStyle(tillcs);
  // const StyleValue = String(SelectStyle.getPropertyValue('--sample')).trim();
  // console.log((3/85.6));
  const animOrg = async () => {
    tillcs.removeEventListener('animationend', animOrg)
    tillcs.classList.remove('stop')
    mt.classList.remove('stop')
    kz.classList.remove('stop')
    tn.classList.remove('stop')
    const rand = arrayShuffle(tillArr)
    loopImg(rand)
  }
  const animanim = async () => {
    tillcs.classList.add('play')
    mt.classList.add('play')
    kz.classList.add('play')
    tn.classList.add('play')
    wv.classList.add('play')
    wv2.classList.add('play')
  }
  const animanim2 = async () => {
    console.log('animanim2')
    mt.classList.remove('play')
    kz.classList.remove('play')
    tn.classList.remove('play')
    wv.classList.remove('play')
    wv2.classList.remove('play')
    mt.classList.add('stop')
    kz.classList.add('stop')
    tn.classList.add('stop')
    tillcs.classList.add('img-hide')
    tillcs.classList.remove('play')
    tillcs.classList.add('stop')
    tillcs.addEventListener('animationend', animOrg)
  }
  const loopImg = (arr) => {
    tillcs.innerHTML = ''
    let cnt = 0
    arr.forEach((ta) => {
      const li = document.createElement('li')
      li.classList.add('tcard')
      const img = document.createElement('img')
      img.src = ta
      img.addEventListener('load', () => {
        cnt++
        // console.log('load ', cnt)
        if (tillArr.length <= cnt) {
          // console.log('loop end')
          document.querySelector('.loader').style.display = 'none'
          tillcs.classList.remove('img-hide')
          const cw = tillcs.querySelector('.tcard').clientWidth
          if (cw) tillcs.style.setProperty('--card-radius', `${cw * (3/85.6)}30px`)
          animanim()
        }
      })
      li.appendChild(img)
      tillcs.appendChild(li)
    })
  }
  if (tillcs && mt && kz && tn) {
    loopImg(arrayShuffle(tillArr))
    sid = setInterval(animanim2, 10000);
  }
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') {
      if (!sid) sid = setInterval(animanim2, 10000)
      console.log(sid);
      document.querySelector('body').style.animationPlayState = 'running'
    } else {
      if (sid) sid = clearInterval(sid)
      console.log(sid);
      document.querySelector('body').style.animationPlayState = 'pause'
    }
  })
})

